var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Notification",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27.709,
    height: 32.596,
    viewBox: "0 0 27.709 32.596",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-2 {\r\n        opacity: 0.4;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6e43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e61800"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_425-2",
    className: "cls-1",
    d: "M0,19.415v-.333a6.1,6.1,0,0,1,.977-3,8.325,8.325,0,0,0,1.939-3.839c.073-1.087,0-2.2.073-3.3C3.517,3.651,8.752,0,13.768,0h.146c5.1,0,10.207,3.651,10.761,8.939.1,1.087,0,2.217.087,3.3A8.166,8.166,0,0,0,26.7,16.082a5.771,5.771,0,0,1,1.006,3v.333a5.961,5.961,0,0,1-1.458,3.941A7.309,7.309,0,0,1,21.6,25.63a61.474,61.474,0,0,1-15.646,0,7.308,7.308,0,0,1-4.593-2.275A5.873,5.873,0,0,1,0,19.415Z",
    transform: "translate(0 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    className: "cls-2",
    d: "M6.679.032C5.643-.04,4.8.032,3.952.032A10.344,10.344,0,0,0,1.458.293C.758.452,0,.829,0,1.626a2.576,2.576,0,0,0,1.137,1.9,6.065,6.065,0,0,0,4.375,1.2A5.082,5.082,0,0,0,9.289,2.6,1.443,1.443,0,0,0,9.041.583h0A5.424,5.424,0,0,0,6.679.032Z",
    transform: "translate(9.073 27.829)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.62aa764ae4f7f5c69b7d9aee442905c0.svg";
export { ForwardRef as ReactComponent };